import { gameProviderTypes } from '@configs/layout';
import { Countries2DigitCode } from '@models/commonModel';
import { alertClassType, alertPeirodType } from '@models/manager/account/account';

const ExpandableListBox = ({ data }) => {
  const { alertClass, store, alertPeirod, country, appList } = data;
  return (
    <div className="tb-basic-inner">
      <table>
        <colgroup>
          <col />
        </colgroup>
        <thead>
          <tr></tr>
        </thead>
        <tbody>
          <tr className="data-active">
            <td colSpan={6}>
              <table>
                <colgroup>
                  <col width="20%" />
                  <col width="29%" />
                  <col width="18%" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="col">Alert Class</th>
                    <td>
                      {alertClass.map((item, index) => {
                        if (index === 0) {
                          return alertClassType[`${item}`];
                          // } else if (alertClass.length > 0 && alertClass.length - 1 === index) {
                          //   return ` / ${alertClassType[`${item}`]}`;
                        } else {
                          return ` / ${alertClassType[`${item}`]}`;
                        }
                      })}
                    </td>
                    <th scope="col" rowSpan={4}>
                      Alert Class
                    </th>
                    <td rowSpan={4}>
                      <ol className="chart-ranking-data">
                        {appList?.map((appObj) => (
                          <li key={appObj.appId}>
                            <div className="game-img">
                              <img src={appObj.icon} />
                            </div>
                            <div className="game-info">
                              <p className="game-tit">{appObj.title}</p>
                              <p className="game-desc">{appObj.developer}</p>
                            </div>
                          </li>
                        ))}
                      </ol>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">Application Store</th>
                    <td>{gameProviderTypes.AppleAppStore === store ? 'Google Play Store' : ' Apple App Store'}</td>
                  </tr>
                  <tr>
                    <th scope="col">Countries</th>
                    <td>
                      <div className="flag-country">
                        <div className="flag-svg">
                          <div id="story--flags--primary">
                            <span style={{ fontSize: 24 }}>
                              <img
                                alt=""
                                src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${country}.svg`}
                              />
                            </span>
                          </div>
                        </div>
                        <p className="flag-country-txt">
                          {' '}
                          {Countries2DigitCode.find((item) => item.code === country).name}
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">Alert Period</th>
                    <td>{alertPeirodType[`${alertPeirod}`]}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ExpandableListBox;
